import { render, staticRenderFns } from "./ImsAllOfferingList.vue?vue&type=template&id=c06681b2&scoped=true&"
import script from "./ImsAllOfferingList.vue?vue&type=script&lang=js&"
export * from "./ImsAllOfferingList.vue?vue&type=script&lang=js&"
import style0 from "./ImsAllOfferingList.vue?vue&type=style&index=0&id=c06681b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06681b2",
  null
  
)

export default component.exports